import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


import { l10nConfig, initL10n, LocaleValidation, AppStorage, HttpTranslationLoader } from '../l10n-config';
import { L10nTranslationModule, L10nIntlModule } from 'angular-l10n';
import {PatientService} from './patient.service';

import { DxMenuModule, DxSelectBoxModule, DxCheckBoxModule, DxValidatorModule, DxValidationSummaryModule, DxTextBoxModule, DxFormModule, DxLoadPanelModule, DxRadioGroupModule, DxSparklineModule, DxValidationGroupModule, DxFileUploaderModule, DxPopupModule } from 'devextreme-angular';
import { DxDataGridModule,DxTextAreaModule,DxButtonModule,
   DxBulletModule,
   DxTemplateModule, DxListModule, DxSpeedDialActionModule, DxDateBoxModule, DxNumberBoxModule } from 'devextreme-angular';

import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { PatientHealthDataComponent } from './patient-health-data/patient-health-data.component';
import { PatientAddictionsComponent } from './patient-addictions/patient-addictions.component';
import { PatientDetailsComponent } from './patient-details/patient-details.component';
import { ThryveModule } from '../module-thryve/thryve.module';
import { SharedModule } from '../shared/shared.module';
import { MeasuredDataComponent } from './measured-data/measured-data.component';
import { LabDataComponent } from './lab-data/lab-data.component';
import { SmartSetComponent } from './smart-set/smart-set.component';
import { PatientTasksComponent } from './patient-tasks/patient-tasks.component';
import { EvaluationComponent } from '../module-clinic/evaluation/evaluation.component';
import { NotesComponent } from './notes/notes.component';
import { StatisticsModule } from '../statistics/statistics.module';
import { BloodOxygenComponent } from './blood-oxygen/blood-oxygen.component';
import { AnterogradEvaComponent } from '../module-clinic/evaluation/anterograd-eva/anterograd-eva.component';
import { AcerInitEvaComponent } from '../module-clinic/evaluation/acer-init-eva/acer-init-eva.component';
import { SpellBackwardsEvaComponent } from '../module-clinic/evaluation/spell-backwards-eva/spell-backwards-eva.component';
import { BvrtEvaComponent } from '../module-clinic/evaluation/bvrt-eva/bvrt-eva.component';
//import dxFileUploader from 'devextreme/ui/file_uploader';


@NgModule({ declarations: [
        PatientProfileComponent,
        PatientHealthDataComponent,
        PatientAddictionsComponent,
        PatientDetailsComponent,
        MeasuredDataComponent,
        LabDataComponent,
        SmartSetComponent,
        PatientTasksComponent,
        EvaluationComponent,
        NotesComponent,
        BloodOxygenComponent,
        AnterogradEvaComponent,
        AcerInitEvaComponent,
        SpellBackwardsEvaComponent,
        BvrtEvaComponent
    ],
    exports: [
        PatientDetailsComponent,
        PatientProfileComponent,
        MeasuredDataComponent,
        LabDataComponent,
        SmartSetComponent,
        PatientTasksComponent,
        EvaluationComponent,
        NotesComponent,
        BloodOxygenComponent
    ], imports: [CommonModule,
        L10nTranslationModule.forRoot(l10nConfig, {
            storage: AppStorage,
            translationLoader: HttpTranslationLoader
        }),
        L10nIntlModule,
        DxMenuModule,
        DxListModule,
        DxTextAreaModule,
        DxSelectBoxModule,
        DxCheckBoxModule,
        DxDataGridModule,
        DxTemplateModule,
        DxBulletModule,
        DxRadioGroupModule,
        DxDateBoxModule,
        DxButtonModule,
        DxFileUploaderModule,
        DxNumberBoxModule,
        DxValidatorModule,
        DxPopupModule,
        DxValidationGroupModule,
        DxSpeedDialActionModule,
        DxValidationSummaryModule,
        DxTextBoxModule,
        DxFormModule,
        DxLoadPanelModule,
        DxSparklineModule,
        SharedModule,
        ThryveModule,
        StatisticsModule], providers: [
        PatientService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
/**
 * Péciens adatainak kezelését tartalmazó modul
 */

export class PatientModule { }
